export default {"src":"/_next/static/media/left-arrow.3bb80423.svg","height":54,"width":29,"blurWidth":0,"blurHeight":0};